<template>
  <transition name="modal" tag="div">
    <div v-if="visible" class="my-modal-backdrop" @click.self="$emit('close')">
      <div class="modal-dialog" :style="`max-width: ${width}`">
        <div class="modal-content" ref="modalContent">
          <header class="modal-header">
            <slot name="header"></slot>
          </header>
          <main class="modal-body">
            <slot name="body"></slot>
          </main>
          <footer class="modal-footer">
            <slot name="footer">
              <button v-if="closable" type="button" class="btn btn-primary" @click.prevent="$emit('close')">{{$t('js.actions.close')}}</button>
            </slot>
          </footer>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
export default {
  name: "Modal",
  props:{
    visible: {
      type: Boolean,
      required: true
    },
    closable: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '500px'
    }
  },
  watch: {
    showModal: function(value){
      if(value) {
        this.$emit('opened')
      } else {
        this.$emit('closed')
      }
    }
  }
}
</script>

<style>
  .my-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #0007;
    backdrop-filter: blur(4px);
    z-index: 1000;
  }

  .modal-enter-active {
    animation: modalEnter 250ms;
  }

  .modal-leave-active {
    animation: modalLeave 250ms;
  }

  @keyframes modalLeave {
    from {
      opacity: 1.0;
    }
    to {
      opacity: 0.0;
    }
  }

  @keyframes modalEnter {
    from {
      opacity: 0.0;
    }
    to {
      opacity: 1.0;
    }
  }
</style>